import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from '../plugins/logger'

import * as actions from './actions'
import * as getters from './getters'
import evaluate from './modules/evaluate'
import user from './modules/user'
import company from './modules/company'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    evaluate,
    user,
    company
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js